/** Популярные направления для онбординга и настроек */
export const POPULAR_SPORTS = [
  "Дзюдо",
  "Самбо",
  "Бокс",
  "Карате",
  "Тхэквондо",
  "Греко-римская борьба",
  "ОФП",
  "Растяжка",
  "Футбол",
  "Гимнастика",
];

export default POPULAR_SPORTS;
